export default {
    pageTitle: '我的会员',
    vip: '我的会员',
    card1: '白金卡',
    card2: '钻石卡',
    card3: '黑金卡',
    card4: '黑金',
    wan: '万',
    tip1: '上月日均资产≥',
    tip1after: '万USD，可享有',
    v1: 'V1权益',
    v2: 'V2权益',
    v3: 'V3权益',
    qrcode1: '保存下方二维码，微信扫一扫',
    qrcode2: '添加您的专属客户经理领取特权',
    add: '已添加',
    lookMoney: '查看资产',
    privilege: '尊享特权',
    gift: '尊享礼遇',
    giftLevel: '礼遇等级',
    giftDes: '「复星财富星级礼遇」是面向高净值投资者的全球一站式财富管理综合礼遇服务。',
    giftLevelDes: '礼遇分为3个等级，每个等级由过去一个自然月的日均AUM资产决定，等级越高，享受到的专属礼遇服务越多。',
    privilege1: '健康保障',
    privilege2: '快乐生活',
    privilege3: '旅游休闲',
    privilege4: '权益礼盒',
    privilege5: '特权联动',
    btn1: '存入资金',
    btn2: '前往交易',
    level: '当前等级',
    nodb: '未达标',
    qidai: '更多权益，敬请期待',
    nosatisfy: '您的上月日均资产未达到领取条件',
    lookMore: '查看更多',
    lookLess: '收起更多',
    comingSoonTips: '高客权益功能即将上线，敬请期待。',
    aumyip: '*日均AUM资产达标后次月1号自动升级权益',
    qy: '权益',
    autoTip: '将自动获得',
    ling: '另',
    tips: '证券价格有时可能会非常波动。证券价格可升可跌，甚至变成毫无价值。买卖证券未必一定能够赚取利润，反而可能会招致损失。以上内容纯粹仅供参考之用，并非及不应被视为出售建议、推销或游说认购任何投资产品。在进行任何交易之前，客户应根据个人目标及本身状况作出投资决定，倘若有需要，应寻求独立专业意见。本内容如有任何更改，恕不另行通知。',
    dialogTip: '将离开星财富APP前往【星财甄享汇】微信小程序，进行权益的查看与使用',
    dialogTip1: '请先前往【我的】- 【关于我们】更新APP版本，更新后可查看财富甄享汇内容详情',
    dialogBtn: '确认前往',
    dialogBtn1: '立即更新',
}
